import React from 'react';
import DepartmentInformation from '@upgrade/ui-utils/constants/department-information';
import moment from 'moment';
import { Trans as _Trans } from "@lingui/react";
import { formatConventionalHour } from '@upgrade/ui-utils/formatters/date-local';
const formatDay = (i, abbr) => moment.utc(i % 7, 'd').format(abbr ? 'ddd' : 'dddd');
const formatHour = hour => formatConventionalHour(hour, 'H');
const TIMEZONE_MAP = {
  'America/Los_Angeles': /*#__PURE__*/React.createElement(_Trans, {
    id: "lFzhjw",
    message: "PT"
  }),
  'America/New_York': /*#__PURE__*/React.createElement(_Trans, {
    id: "P3/OHm",
    message: "ET"
  })
};
const formatTimezone = timezone => TIMEZONE_MAP[timezone || 'America/Los_Angeles'];

/**
 * Render the support hours for a department
 *
 * @param {Object} props
 * @param {string} [props.department] - The department to get the hours for
 * @param {boolean} [props.abbreviatedDays] - Whether to use abbreviated days
 * @param {string | React.ElementType} [props.as] - The component to wrap the hours in
 * @param {boolean} [props.inline] - Whether to render the hours inline
 */
const SupportHours = ({
  department,
  as,
  abbreviatedDays = false
}) => {
  if (!department) return null;
  const {
    hoursOfOperation
  } = DepartmentInformation[department];
  const Comp = as ?? 'div';
  return hoursOfOperation.map(({
    dayOfWeek,
    hours,
    timezone
  }) => {
    const startDay = formatDay(dayOfWeek.start, abbreviatedDays);
    const endDay = formatDay(dayOfWeek.end, abbreviatedDays);
    const startHour = formatHour(hours.start);
    const endHour = formatHour(hours.end);
    const formattedTimezone = formatTimezone(timezone);
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: `${dayOfWeek.start}${timezone}`
    }, /*#__PURE__*/React.createElement(Comp, null, /*#__PURE__*/React.createElement(_Trans, {
      id: "hxXxzG",
      message: "{startDay} - {endDay}, {startHour} - {endHour} {formattedTimezone}",
      values: {
        startDay: startDay,
        endDay: endDay,
        startHour: startHour,
        endHour: endHour,
        formattedTimezone: formattedTimezone
      }
    })));
  });
};
export default SupportHours;
//# sourceMappingURL=support-hours.js.map